import { render } from "./proShow.vue?vue&type=template&id=688b70e2&scoped=true"
import script from "./proShow.vue?vue&type=script&lang=js"
export * from "./proShow.vue?vue&type=script&lang=js"

import "./proShow.vue?vue&type=style&index=0&id=688b70e2&scoped=true&lang=scss"

import exportComponent from "D:\\SelfCode\\ktpro\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-688b70e2"]])

export default __exports__